module.exports = __webpack_public_path__ + "img/docker-vector-logo.8c9a1a04.svg";